import React from 'react'
import { BCol, BRow, BText } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../../../hoc'

import styles from './styles.scss'

type Props = {
  icon: any
  message: object
}

export const Panel: React.FC<Props & IntlInterface> = ({
  icon,
  message,
  translate,
}: Props & IntlInterface) => (
  <BCol theme="mb-4" xs={12} sm={4}>
    <BRow>
      <BCol theme="d-flex col-auto justify-content-center align-items-center pr-0 pr-sm-3" sm={12}>
        <div className={styles.imageContainer}>{icon}</div>
      </BCol>
      <BCol
        theme="d-flex justify-content-left justify-content-sm-center align-items-center align-items-sm-start text-left text-sm-center pt-0 pt-sm-2"
        sm={12}>
        <BText theme="mb-0 pb-0">{translate(message)}</BText>
      </BCol>
    </BRow>
  </BCol>
)

export default intl(Panel)
